
//CREATE ROUTES LIST
const routes = [
    // Protected Routes
    {
        path: '/',
        name: 'MainDashboard',
        component: () => import('../components/views/MainDashboard.vue'),
        meta: { requiresAuth: true, roles: ['Admin', 'Owner', 'SuperAdmin', 'Viewer'] }
    },
    {
        path: '/UserList',
        name: 'UserList',
        component: () => import('../components/views/users/UserList.vue'),
        meta: { requiresAuth: true, roles: ['Admin', 'Owner', 'SuperAdmin'] }
    },
    {
        path: '/AddUser',
        name: 'AddUser',
        component: () => import('../components/views/users/AddUser.vue'),
        meta: { requiresAuth: true, roles: ['Admin', 'Owner', 'SuperAdmin'] }
    },
    {
        path: '/EditUser/:id',
        name: 'EditUser',
        component: () => import('../components/views/users/EditUser.vue'),
        props: true,
        meta: { requiresAuth: true }
    },
    {
        path: '/EditPermissions/:userId/:accountId',
        name: 'EditPermissions',
        component: () => import('../components/views/users/EditPermissions.vue'),
        props: true,
        meta: { requiresAuth: true }
    },
    {
        path: '/AccountList',
        name: 'Accounts',
        component: () => import('../components/views/accounts/AccountList.vue'),
        meta: { requiresAuth: true, roles: ['Admin', 'Owner', 'SuperAdmin'] }
    },
    {
        path: '/AddAccount',
        name: 'AddAccount',
        component: () => import('../components/views/accounts/AddAccount.vue'),
        meta: { requiresAuth: true, roles: ['Admin', 'Owner', 'SuperAdmin'] }
    },
    {
        path: '/EditAccount/:id',
        name: 'EditAccount',
        component: () => import('../components/views/accounts/EditAccount.vue'),
        props: true,
        meta: { requiresAuth: true, roles: ['Admin', 'Owner', 'SuperAdmin'] }
    },
    {
        path: '/AuditLogs',
        name: 'AuditLogs',
        component: () => import('../components/views/audit/AuditLogList.vue'),
        meta: { requiresAuth: true, roles: ['Admin', 'Owner', 'SuperAdmin'] }
    },
    {
        path: '/Devices/Dashboard',
        name: 'DeviceDashboard',
        component: () => import('../components/views/devices/DeviceDashboard.vue'),
        meta: { requiresAuth: true, roles: ['Admin', 'Owner', 'SuperAdmin', 'Viewer'] }
    },
    {
        path: '/DeviceList',
        name: 'DevicesList',
        component: () => import('../components/views/devices/DeviceList.vue'),
        meta: { requiresAuth: true, roles: ['Admin', 'Owner', 'SuperAdmin', 'Viewer'] }
    },
    {
        path: '/AddDevice/:id?',
        name: 'AddDevice',
        component: () => import('../components/views/devices/AddDevice.vue'),
        meta: { requiresAuth: true, roles: ['Admin', 'Owner', 'SuperAdmin'] }
    },
    {
        path: '/DeviceLogs/:id',
        name: 'DeviceLogs',
        component: () => import('../components/views/devices/DeviceLogs.vue'),
        props: true,
        meta: { requiresAuth: true, roles: ['Admin', 'Owner', 'SuperAdmin'] }
    },
    {
        path: '/Devices/Map',
        name: 'DeviceMap',
        component: () => import('../components/views/devices/DeviceMap.vue'),
        meta: { requiresAuth: true, roles: ['Admin', 'Owner', 'SuperAdmin', 'Viewer'] }
    },
    {
        path: '/Devices/Alerts',
        name: 'Alerts',
        component: () => import('../components/views/devices/AlertsList.vue'),
        meta: { requiresAuth: true, roles: ['Admin', 'Owner', 'SuperAdmin', 'Viewer'] }
    },
    {
        path: '/Devices/BleSetup',
        name: 'BleSetup',
        component: () => import('../components/views/devices/BleSetup.vue'),
        meta: { requiresAuth: true, roles: ['Admin', 'Owner', 'SuperAdmin'] }
    },
    {
        path: '/Devices/Notifications',
        name: 'Notifications',
        component: () => import('../components/views/notifications/NotificationsInbox.vue'),
        meta: { requiresAuth: true, alwaysAllow: true }
    },
    // Shop routes
    {
        path: '/Shop/Dashboard',
        name: 'ShopDashboard',
        component: () => import('../components/views/shop/ShopDashboard.vue'),
        meta: { requiresAuth: true, roles: ['Admin', 'Owner', 'SuperAdmin', 'Viewer'] }
    },
    {
        path: '/Shop/Products',
        name: 'ShopProducts',
        component: () => import('../components/views/shop/ShopProducts.vue'),
        meta: { requiresAuth: true, roles: ['Admin', 'Owner', 'SuperAdmin', 'Viewer'] }
    },
    {
        path: '/Shop/Cart',
        name: 'ShopCart',
        component: () => import('../components/views/shop/ShopCart.vue'),
        meta: { requiresAuth: true, roles: ['Admin', 'Owner', 'SuperAdmin', 'Viewer'] }
    },
    {
        path: '/Shop/MyOrders',
        name: 'ShopMyOrders',
        component: () => import('../components/views/shop/ShopMyOrders.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/Shop/Orders',
        name: 'AdminOrders',
        component: () => import('../components/views/shop/AdminOrders.vue'),
        meta: { requiresAuth: true, roles: ['Admin', 'Owner', 'SuperAdmin'] }
    },
    {
        path: '/Shop/POS',
        name: 'ShopPOS',
        component: () => import('../components/views/shop/ShopPOS.vue'),
        meta: { requiresAuth: true, roles: ['Admin', 'Owner', 'SuperAdmin'] }
    },
    {
        path: '/Shop/SalesSummary',
        name: 'ShopSalesSummary',
        component: () => import('../components/views/shop/ShopSalesSummary.vue'),
        meta: { requiresAuth: true, roles: ['Admin', 'Owner', 'SuperAdmin'] }
    },
    {
        path: '/Shop/CashFlow',
        name: 'ShopCashFlow',
        component: () => import('../components/views/shop/ShopCashFlow.vue'),
        meta: { requiresAuth: true, roles: ['Admin', 'Owner', 'SuperAdmin'] }
    },
    {
        path: '/Shop/AddProduct/:id?',
        name: 'AddProduct',
        component: () => import('../components/views/shop/AddProduct.vue'),
        meta: { requiresAuth: true, roles: ['Admin', 'Owner', 'SuperAdmin']}
    },
    //End shop routes 

    // Customer Portal
    {
        path: '/Customer/Credit',
        name: 'CustomerCredit',
        component: () => import('../components/views/customer/CustomerCredit.vue'),
        meta: { requiresAuth: true, roles: ['Customer'] }
    },
    {
        path: '/Customer/CreditRequests',
        name: 'CustomerCreditRequests',
        component: () => import('../components/views/customer/CustomerCreditRequests.vue'),
        meta: { requiresAuth: true, roles: ['Customer'] }
    },
    
    // End Protected Routes

    //Farm Routes
    {
        path: '/Farm/FarmDashboard',
        name: 'FarmDashboard',
        component: () => import('../components/views/farm/FarmDashboard.vue'),
        meta: { requiresAuth: true, roles: ['Admin', 'Owner', 'SuperAdmin', 'Viewer'] }
    },
    {
        path: '/Farm/Farms',
        name: 'FarmList',
        component: () => import('../components/views/farm/farm/FarmList.vue'),
        meta: { requiresAuth: true, roles: ['Admin', 'Owner', 'SuperAdmin', 'Viewer'] }
    },
    {
        path: '/Farm/Add',
        name: 'AddFarm',
        component: () => import('../components/views/farm/farm/AddFarm.vue'),
        meta: { requiresAuth: true, roles: ['Admin', 'Owner', 'SuperAdmin'] }
    },
    {
        path: '/Farm/Edit/:id',
        name: 'EditFarm',
        props: true,
        component: () => import('../components/views/farm/farm/EditFarm.vue'),
        meta: { requiresAuth: true, roles: ['Admin', 'Owner', 'SuperAdmin'] }
    },
    {
        path: '/Farm/AnimalList',
        name: 'AnimalList',
        component: () => import('../components/views/farm/animal/AnimalList.vue'),
        meta: { requiresAuth: true, roles: ['Admin', 'Owner', 'SuperAdmin', 'Viewer'] }
    },
    {
        path: '/Farm/InventoryView',
        name: 'InventoryView',
        component: () => import('../components/views/farm/inventory/InventoryView.vue'),
        meta: { requiresAuth: true, roles: ['Admin', 'Owner', 'SuperAdmin', 'Viewer'] }
    },
    {
        path: '/Farm/PnlReport',
        name: 'PnlReport',
        component: () => import('../components/views/farm/PnlReport.vue'),
        meta: { requiresAuth: true, roles: ['Admin', 'Owner', 'SuperAdmin'] }
    },
    {
        path: '/farm/addAnimal',
        name: 'AddAnimal',
        component: () => import('../components/views/farm/animal/AddAnimal.vue'),
        meta: { requiresAuth: true, roles: ['Admin', 'Owner', 'SuperAdmin'] }
    },
    {
        path: '/Farm/EditAnimal/:id',
        name: 'EditAnimal',
        props: true,
        component: () => import('../components/views/farm/animal/EditAnimal.vue'),
        meta: { requiresAuth: true, roles: ['Admin', 'Owner', 'SuperAdmin'] }
    },
    {
        path: '/Farm/AddAnimalEvent/:id?',
        name: 'AddAnimalEvent',
        props: true,
        component: () => import('../components/views/farm/animal/AddAnimalEvent.vue'),
        meta: { requiresAuth: true, roles: ['Admin', 'Owner', 'SuperAdmin'] }
    },
    {
        path: '/Farm/AnimalEvents',
        name: 'AnimalEventList',
        component: () => import('../components/views/farm/animal/AnimalEventList.vue'),
        meta: { requiresAuth: true, roles: ['Admin', 'Owner', 'SuperAdmin', 'Viewer'] }
    },
    {
        path: '/Farm/AnimalDeviceLink/:id',
        name: 'AnimalDeviceLink',
        props: true,
        component: () => import('../components/views/farm/animal/AnimalDeviceLink.vue'),
        meta: { requiresAuth: true, roles: ['Admin', 'Owner', 'SuperAdmin'] }
    },
    {
        path: '/Farm/AnimalTypes',
        name: 'AnimalTypeList',
        component: () => import('../components/views/farm/animal/AnimalTypeList.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/Farm/AddAnimalType',
        name: 'AddAnimalType',
        component: () => import('../components/views/farm/animal/AddAnimalType.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/Farm/EditAnimalType/:id',
        name: 'EditAnimalType',
        props: true,
        component: () => import('../components/views/farm/animal/EditAnimalType.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/Farm/AnimalBreeds',
        name: 'AnimalBreedList',
        component: () => import('../components/views/farm/animal/AnimalBreedList.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/Farm/AddAnimalBreed',
        name: 'AddAnimalBreed',
        component: () => import('../components/views/farm/animal/AddAnimalBreed.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/Farm/EditAnimalBreed/:id',
        name: 'EditAnimalBreed',
        props: true,
        component: () => import('../components/views/farm/animal/EditAnimalBreed.vue'),
        meta: { requiresAuth: true }
    },
    // End Farm Routes

    // Sales Routes (invoicing — quotes, invoices, customers).
    // System-level, not a Shop sub-feature: an invoice can be raised for a
    // website build, a farm sale or a device install.
    // NOTE: key order MUST stay path -> name -> meta with single quotes.
    // scripts/build-permissions-registry.js parses this file with a regex
    // that requires exactly that order, and silently DROPS any route written
    // differently — which then can never be granted a permission.
    {
        path: '/Sales/Invoices',
        name: 'SalesInvoiceList',
        component: () => import('../components/views/sales/SalesInvoiceList.vue'),
        meta: { requiresAuth: true, roles: ['Admin', 'Owner', 'SuperAdmin', 'Viewer'] }
    },
    {
        path: '/Sales/Invoices/Edit/:id?',
        name: 'AddSalesInvoice',
        component: () => import('../components/views/sales/AddSalesInvoice.vue'),
        props: true,
        meta: { requiresAuth: true, roles: ['Admin', 'Owner', 'SuperAdmin'] }
    },
    {
        path: '/Sales/Invoices/View/:id',
        name: 'SalesInvoiceView',
        component: () => import('../components/views/sales/SalesInvoiceView.vue'),
        props: true,
        meta: { requiresAuth: true, roles: ['Admin', 'Owner', 'SuperAdmin', 'Viewer'] }
    },
    // End Sales Routes


    // Public Routes
    {
        path: '/SignUp',
        name: 'SignUp',
        component: () => import('../components/auth/SignUp.vue'),
        meta: { guestOnly: true }
    },
    {
        path: '/LogIn',
        name: 'LogIn',
        component: () => import('../components/auth/LogIn.vue'),
        meta: { guestOnly: true }
    },
    {
        path: '/ResetPassword',
        name: 'ResetPassword',
        component: () => import('../components/auth/ResetPassword.vue'),
        meta: { guestOnly: true }
    },
    {
        path: '/ForgotPassword',
        name: 'ForgotPassword',
        component: () => import('../components/auth/ForgotPassword.vue'),
        meta: { guestOnly: true }
    }
    // End Public Routes
]

export default routes;